/** @jsx jsx */

import { Button, Grid, jsx } from 'theme-ui'

import { Link } from 'gatsby'
import StyledWrapper from '../../Generic/StyledWrapper'
import Heading from '~/components/IntlComponents/Heading'

function TextSectionWithVideo({
  containerStyle,
  buttonStyle,
  url,
  buttonUrl,
  isHero,
  buttonText = 'Shop All',
  subheadingText = 'We know, we know: another healthy noodle that claims to taste good. But we really cracked the code, folks.',
  headingText = 'Tasting is believing',
}) {
  return (
    <Grid
      columns={[1, 2]}
      sx={{
        paddingY: 50,
        paddingX: 50,
        justifyContent: ['center', 'initial'],
        justifyItems: ['center', 'initial'],
        textAlign: ['center', 'initial'],
        ...containerStyle,
      }}
    >
      <div
        sx={{
          alignSelf: 'center',
        }}
      >
        <StyledWrapper>
          <Heading variant="text.h1">{headingText}</Heading>
        </StyledWrapper>
        <StyledWrapper>
          <div
            sx={{
              marginY: 30,
            }}
          >
            {subheadingText}
          </div>
        </StyledWrapper>

        <StyledWrapper>
          <Link to={buttonUrl}>
            <Button
              sx={{
                ...buttonStyle,
                display: ['none', 'initial'],
              }}
            >
              {buttonText}
            </Button>
          </Link>
        </StyledWrapper>
      </div>
      <div
        sx={{
          clipPath: isHero ? 'none' : 'url(#videoClipPath)',
          height: 'fit-content',
        }}
      >
        <video
          sx={{
            position: 'relative',
            width: '100%',
          }}
          src={'https:' + url} // title={videoTitle}
          autoPlay
          playsInline
          loop
          muted
          controls={false}
        />

        <svg width="0" height="0">
          <defs>
            <clipPath id="videoClipPath" clipPathUnits="objectBoundingBox">
              <path d="M0.474,1 C0.473,1,0.472,1,0.471,1 C0.456,1,0.443,0.991,0.434,0.976 L0.434,0.975 C0.426,0.961,0.407,0.958,0.397,0.969 L0.397,0.97 C0.386,0.981,0.371,0.986,0.356,0.981 C0.342,0.977,0.329,0.965,0.322,0.947 L0.321,0.947 C0.315,0.931,0.297,0.923,0.286,0.931 L0.285,0.932 C0.273,0.941,0.258,0.941,0.244,0.933 C0.23,0.924,0.219,0.909,0.214,0.89 L0.214,0.889 C0.209,0.871,0.192,0.858,0.181,0.863 L0.18,0.863 C0.167,0.868,0.152,0.864,0.14,0.85 C0.127,0.837,0.118,0.818,0.116,0.798 L0.116,0.796 C0.114,0.777,0.1,0.758,0.088,0.758 L0.087,0.758 C0.074,0.756,0.06,0.744,0.051,0.725 C0.041,0.706,0.037,0.683,0.04,0.663 L0.04,0.662 L0.04,0.661 C0.043,0.642,0.036,0.616,0.024,0.607 L0.024,0.607 L0.023,0.606 C0.011,0.595,0.003,0.575,0.001,0.551 C-0.001,0.526,0.003,0.503,0.012,0.487 L0.012,0.486 L0.013,0.485 C0.022,0.472,0.025,0.443,0.018,0.426 L0.018,0.425 L0.018,0.424 C0.012,0.405,0.012,0.381,0.019,0.359 C0.025,0.337,0.037,0.321,0.05,0.315 L0.05,0.315 L0.051,0.314 C0.063,0.31,0.075,0.287,0.074,0.268 V0.266 C0.074,0.246,0.081,0.225,0.092,0.209 C0.104,0.193,0.118,0.185,0.131,0.187 L0.132,0.187 C0.144,0.19,0.16,0.173,0.163,0.155 L0.163,0.154 C0.167,0.134,0.177,0.117,0.191,0.106 C0.204,0.096,0.219,0.094,0.232,0.101 L0.232,0.101 C0.244,0.108,0.261,0.098,0.267,0.081 L0.267,0.08 C0.273,0.062,0.285,0.048,0.3,0.042 C0.314,0.035,0.329,0.038,0.341,0.048 L0.341,0.049 C0.351,0.059,0.37,0.053,0.377,0.038 L0.378,0.038 C0.386,0.021,0.399,0.011,0.414,0.008 C0.429,0.005,0.443,0.011,0.453,0.024 L0.454,0.025 C0.463,0.037,0.482,0.036,0.49,0.023 L0.491,0.022 C0.5,0.008,0.514,0.001,0.529,0.001 C0.544,0.002,0.558,0.011,0.567,0.027 L0.567,0.027 C0.575,0.041,0.594,0.045,0.604,0.033 L0.604,0.033 C0.615,0.021,0.63,0.017,0.644,0.021 C0.659,0.026,0.672,0.038,0.679,0.055 L0.679,0.056 C0.686,0.072,0.704,0.08,0.715,0.071 L0.715,0.071 C0.727,0.062,0.742,0.062,0.756,0.07 C0.771,0.078,0.782,0.094,0.787,0.113 L0.787,0.114 C0.791,0.131,0.808,0.145,0.82,0.139 L0.821,0.139 C0.834,0.134,0.849,0.139,0.861,0.152 C0.874,0.165,0.883,0.184,0.885,0.205 L0.885,0.206 C0.886,0.225,0.9,0.245,0.913,0.245 L0.914,0.245 C0.927,0.246,0.94,0.258,0.95,0.277 C0.959,0.296,0.963,0.319,0.961,0.34 L0.961,0.341 L0.961,0.342 C0.957,0.36,0.965,0.387,0.976,0.396 L0.977,0.396 L0.978,0.397 C0.989,0.408,0.997,0.428,1,0.452 C1,0.477,0.998,0.5,0.989,0.516 L0.989,0.517 L0.988,0.518 C0.979,0.531,0.976,0.559,0.982,0.576 L0.983,0.577 L0.983,0.578 C0.989,0.598,0.988,0.621,0.982,0.644 C0.975,0.666,0.964,0.682,0.951,0.688 L0.95,0.688 L0.95,0.688 C0.938,0.692,0.926,0.715,0.927,0.735 V0.736 C0.927,0.757,0.92,0.778,0.908,0.794 C0.897,0.81,0.883,0.818,0.87,0.816 L0.869,0.816 C0.857,0.813,0.841,0.829,0.838,0.848 L0.837,0.849 C0.834,0.868,0.824,0.886,0.81,0.896 C0.796,0.907,0.781,0.909,0.769,0.902 L0.768,0.902 C0.757,0.895,0.739,0.905,0.734,0.922 L0.734,0.923 C0.727,0.941,0.715,0.955,0.701,0.961 C0.686,0.967,0.671,0.965,0.66,0.954 L0.66,0.954 C0.649,0.944,0.63,0.95,0.623,0.965 L0.623,0.965 C0.615,0.981,0.602,0.992,0.587,0.995 C0.572,0.997,0.557,0.991,0.547,0.978 L0.547,0.978 C0.538,0.966,0.519,0.967,0.51,0.98 L0.51,0.98 C0.501,0.994,0.488,1,0.474,1"></path>
            </clipPath>
          </defs>
        </svg>
      </div>
      <Link to={buttonUrl}>
        <Button
          sx={{
            ...buttonStyle,
            display: ['initial', 'none'],
          }}
        >
          {buttonText}
        </Button>
      </Link>
    </Grid>
  )
}

export default TextSectionWithVideo
